export default [
  {
    path: "/despesas",
    name: "Despesas",
    props: (route) => (
      {
        iddespesa: route.params.iddespesa,
        selected: true,
      }
    ),
    component: () => import("../views/DespesasView"),
  }
]